<template>
  <el-row>
    <el-col :span="8">
      <h3>Health</h3>
      <br />
      <p><router-link to="/bmi">BMI</router-link></p>
      <p><router-link to="/bodyfat">Body Fat</router-link></p>
    </el-col>
    <el-col :span="8">
      <h3>Maths</h3>
      <br />
      <p><router-link class="nav" to="/percent">Percentage</router-link></p>
      <p><router-link class="nav" to="/bitwise">Bitwise</router-link></p>
    </el-col>
    <el-col :span="8">
      <h3>Other</h3>
      <br />
      <p><router-link class="nav" to="/percent">Conversions</router-link></p>
      <p><router-link class="nav" to="/about">About</router-link></p>
      <p>
        <a href="https://gitlab.com/michjnich/calcs">This repo on GitLab</a>
      </p>
    </el-col>
  </el-row>
</template>

<script>
</script>